import React from 'react';

import { CreateConsultantContext } from './CreateConsultantContext';
import { EditConsultantContext } from './EditConsultantContext';

const useCreateConsultantContext = () => React.useContext(CreateConsultantContext);
const useEditConsultantContext = () => React.useContext(EditConsultantContext);

export { useCreateConsultantContext, useEditConsultantContext };
